import type { ExcludePayload } from '../interface/exclude';
import type { SelectedReason } from '../interface/reasons';

export interface ExcludeFormValues {
  readonly reasons: readonly SelectedReason[];
  readonly note: string;
  readonly caseContext: string;
}

export type ExcludeValidationError = 'reason-required';

type Result =
  | { ok: true; payload: ExcludePayload }
  | { ok: false; errors: ExcludeValidationError[] };

/**
 * Narrow with `result.ok === true`, never `!result.ok`: under this repo's `strict: false`, negation does
 * not narrow a discriminated union (TS2339 on `.errors`).
 */
export function buildExcludePayload(values: ExcludeFormValues): Result {
  const seen = new Set<string>();
  const reasons = values.reasons.filter((r) => (seen.has(r.key) ? false : (seen.add(r.key), true)));
  if (reasons.length === 0) return { ok: false, errors: ['reason-required'] };
  const note = values.note.trim();
  const caseContext = values.caseContext.trim();
  const payload: ExcludePayload = {
    reasons,
    ...(note.length > 0 ? { note } : {}),
    ...(caseContext.length > 0 ? { caseContext } : {})
  };
  return { ok: true, payload };
}
